const Tabs = {

    init() {
        this.el = $('[component="Tabs"]');
        if (!this.el.length) return;

        this.nav = this.el.find("nav button");
        this.bind();
    },

    bind() {
        this.nav.unbind("click").click((evt) => this.onClick($(evt.currentTarget)));
    },

    onClick(tab) {
        this.el.find(".active").removeClass("active");
        const content = tab.closest('[component]').find("#" + tab.data('order'));

        tab.addClass("active");
        content.addClass("active");
    },
}

export default Tabs;